export enum TriggerEvent {
  JOIN_PROGRAM = 'joinProgram',
  COMPLETE_COURSE = 'completeCourse',
  ENROLL_IN_COURSE = 'enrollCourse',
}
